export const PageIntro = ({ overline, title, italic, lead, testId = "page-intro", children }) => (
  <section data-testid={testId} className="max-w-7xl mx-auto px-6 sm:px-12 pt-16 sm:pt-24 pb-12 sm:pb-16">
    <p className="text-[11px] tracking-[0.32em] uppercase font-semibold text-[#374F49] reveal">{overline}</p>
    <h1
      className="font-serif font-medium mt-6 text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#1A2522] reveal"
      style={{ animationDelay: "0.08s" }}
    >
      {title}
      {italic && (
        <>
          <br />
          <span className="italic font-normal">{italic}</span>
        </>
      )}
    </h1>
    <div className="mt-8 inline-block">
      <span className="divider"></span>
    </div>
    {lead && (
      <p className="mt-8 max-w-2xl text-[14px] sm:text-[15px] text-[#495854] leading-[1.8] font-light reveal" style={{ animationDelay: "0.16s" }}>
        {lead}
      </p>
    )}
    {children}
  </section>
);
